/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** An instantaneous point on the time-line represented by a standard date time string */
  Instant: { input: any; output: any; }
  Json: { input: any; output: any; }
  Unit: { input: any; output: any; }
};

export type ActivePresetAudience = {
  __typename?: 'ActivePresetAudience';
  name: Scalars['String']['output'];
  presetAudienceId: Scalars['ID']['output'];
};

export type AudienceCategory = {
  __typename?: 'AudienceCategory';
  code: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AudienceCriterion = {
  __typename?: 'AudienceCriterion';
  code: Scalars['String']['output'];
  createdDate: Scalars['Instant']['output'];
  name: Scalars['String']['output'];
  question: Question;
  questionLocalisations?: Maybe<Array<LocalisedQuestion>>;
};

export type AudienceCriterionInput = {
  code: Scalars['String']['input'];
  createdDate: Scalars['String']['input'];
  name: Scalars['String']['input'];
  question: QuestionInput;
  questionLocalisations?: InputMaybe<Array<LocalisedQuestionInput>>;
};

export type AudienceCriterionOption = {
  __typename?: 'AudienceCriterionOption';
  code: Scalars['String']['output'];
  createdDate: Scalars['Instant']['output'];
  responseOption: ResponseOption;
  responseOptionLocalisations?: Maybe<Array<LocalisedResponseOption>>;
  sinceDate: Scalars['Instant']['output'];
};

export type AudienceCriterionOptionInput = {
  code: Scalars['String']['input'];
  createdDate: Scalars['String']['input'];
  responseOption: ResponseOptionInput;
  responseOptionLocalisations?: InputMaybe<Array<LocalisedResponseOptionInput>>;
  sinceDate: Scalars['String']['input'];
};

export type AudienceCriterionPair = {
  __typename?: 'AudienceCriterionPair';
  criterionCode: Scalars['String']['output'];
  optionCode: Scalars['String']['output'];
};

export type AudienceCriterionPairInput = {
  criterionCode: Scalars['String']['input'];
  optionCode: Scalars['String']['input'];
};

export enum AudienceCriterionState {
  Disabled = 'Disabled',
  Enabled = 'Enabled'
}

export type AudienceMarkupGroup = {
  __typename?: 'AudienceMarkupGroup';
  criterionOptions: Array<AudienceCriterionPair>;
  groupName: Scalars['String']['output'];
  markup: Scalars['Float']['output'];
};

export type AudienceReponseOption = {
  __typename?: 'AudienceReponseOption';
  questionId: Scalars['ID']['output'];
  responseOptionId: Scalars['ID']['output'];
  surveyId: Scalars['ID']['output'];
};

export type CandidateAudience = {
  __typename?: 'CandidateAudience';
  createdDate: Scalars['String']['output'];
  description: Scalars['String']['output'];
  members: Array<DraftStandardAudienceItem>;
  number: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
  surveyId: Scalars['ID']['output'];
};

export type CandidateAudienceInput = {
  createdDate: Scalars['String']['input'];
  description: Scalars['String']['input'];
  members: Array<DraftStandardAudienceItemInput>;
  number: Scalars['Int']['input'];
  rank: Scalars['Int']['input'];
  surveyId: Scalars['ID']['input'];
};

export type CintAudience = {
  __typename?: 'CintAudience';
  countryId: Scalars['Int']['output'];
  dedupeTags?: Maybe<Array<Scalars['String']['output']>>;
  members: Array<FieldworkAudienceMember>;
  panelistPoolJson?: Maybe<Scalars['Json']['output']>;
  quotaGroupsJson?: Maybe<Scalars['Json']['output']>;
  targetPostcodes?: Maybe<Array<Scalars['String']['output']>>;
};

export type CintError = {
  __typename?: 'CintError';
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type ConfigMutations = {
  __typename?: 'ConfigMutations';
  addAudienceMemberMetadata?: Maybe<DraftFieldworkAudienceMember>;
  /** A custom criterion is an audience dimension that Focaldata manage internally (e.g. 'Have you heard of Focaldata?'), without involvement of our panel provider.. This operation adds a new custom criterion to an audience. */
  addCustomCriterion?: Maybe<DraftFieldworkAudienceMember>;
  /** A custom criterion option is a possible answer to a custom criterion (e.g. 'Yes' or 'No').. This operation adds a new option to a given custom criteria. */
  addCustomCriterionOption?: Maybe<DraftCustomAudienceCriterionOption>;
  addCustomCriterionOptionMetadata?: Maybe<Scalars['Unit']['output']>;
  /** Customized standard options are standard criteria with user-defined behaviour. For example, custom age-bands. This operation adds a customized option to a standard audience criterion. */
  addCustomizedCriterionOption?: Maybe<DraftFieldworkAudienceMember>;
  /** Instantiate a fresh fieldwork configuration for a given survey. */
  addFieldwork?: Maybe<Fieldwork>;
  /** Panelist pools allow us to either target specific, or exclude specific respondents from the order. Refer to the Cint API documentation for more information. */
  addOrUpdatePanelistPool?: Maybe<Scalars['Unit']['output']>;
  /** Preset audiences are defined by FD internally to allow convenient set-up of the most common audiences (e.g. Nat Rep). This operation adds a new preset audience to the list of available ones. */
  addPresetAudience?: Maybe<PresetAudienceGql>;
  addStandardCriterionOptionMetadata?: Maybe<Scalars['Unit']['output']>;
  /** Dedupe tags allow us to deduplicate respondents when collecting data. Surveys that have common dedupe tags collect disjoint groups of respondents. Refer to the Cint API documentation for more information. */
  addorUpdateDedupeTags?: Maybe<Scalars['Unit']['output']>;
  /** Allows targeting of respondents from specific postcodes. Refer to the Cint API documentation for more information. */
  addorUpdatePostcodeTarget?: Maybe<Scalars['Unit']['output']>;
  /** An AudienceMarkupGroup denotes a collection of standard criteria where when any of them are added to an audience results in an additional markup being included in the calculation of the cost quote.. This operation adds a new criterion to a given markup group. */
  appendCriteriaToGroup?: Maybe<Scalars['Unit']['output']>;
  clearFeasibilityCache?: Maybe<Scalars['String']['output']>;
  /** An AudienceMarkupGroup denotes a collection of standard criteria where when any of them are added to an audience results in an additional markup being included in the calculation of the cost quote.. This operation creates a new markup group. */
  createMarkupCriteriaGroup?: Maybe<Scalars['Unit']['output']>;
  /** An AudienceMarkupGroup denotes a collection of standard criteria where when any of them are added to an audience results in an additional markup being included in the calculation of the cost quote.. This operation removes a markup group. */
  deleteMarkupCriteriaGroup?: Maybe<Scalars['Unit']['output']>;
  /** A custom criterion is an audience dimension that Focaldata manage internally (e.g. 'Have you heard of Focaldata?'), without involvement of our panel provider.. This operation removes an existing custom criterion from the audience. */
  detachCustomAudienceMember?: Maybe<DetachedCustomAudienceMember>;
  /** A custom criterion option is a possible answer to a custom criterion (e.g. 'Yes' or 'No').. This operation removes an existing option from a given custom criterion. */
  detachCustomCriterionOption?: Maybe<DetachedCustomCriterionOption>;
  /** Customized standard options are standard criteria with user-defined behaviour. For example, custom age-bands. This operation removes a customized option from a standard audience criterion. */
  detachCustomizedCriterionOption?: Maybe<DraftFieldworkAudienceMember>;
  duplicateFieldworkAudience?: Maybe<FieldworkAudience>;
  /** Preset audiences are defined by FD internally to allow convenient set-up of the most common audiences (e.g. Nat Rep). This operation duplicates a preset audience and adds it to the list of available ones. */
  duplicatePresetAudience?: Maybe<PresetAudienceGql>;
  /** Remove question + option text from a particular custom audience member. */
  emptyAudienceCriterion?: Maybe<DraftFieldworkAudienceMember>;
  makeSurveyFeasible?: Maybe<Scalars['String']['output']>;
  moveAudienceMember?: Maybe<DraftFieldworkAudienceMember>;
  /** A custom criterion option is a possible answer to a custom criterion (e.g. 'Yes' or 'No').. This operation changes the position of an existing custom criterion option. */
  moveCustomCriterionOption?: Maybe<DraftCustomAudienceCriterionOption>;
  /** Preset audiences are defined by FD internally to allow convenient set-up of the most common audiences (e.g. Nat Rep). This operation changes the position of a preset audience in the list of available ones. */
  movePresetAudience?: Maybe<PresetAudienceGql>;
  /** Bulk update the question text and response options on a particular custom audience member. */
  pasteInAudienceTitle?: Maybe<DraftFieldworkAudienceMember>;
  /** Bulk insert response options at a particular position for a particular custom audience member. */
  pasteInCriterionOptions?: Maybe<DraftFieldworkAudienceMember>;
  /** Pinning means that the position of a given option is unaffected by any randomisation that may be active. */
  pinOrUnpinResponseOption?: Maybe<DraftCustomAudienceCriterionOption>;
  /** @deprecated This operation has been deprecated, please use the other preset audience mutations to interact with preset audiences. */
  presetAudience?: Maybe<Scalars['Unit']['output']>;
  /** A respondent who chooses an option that does not have a qualification set on it will be screened out of the survey. This operation removes all qualifications from a given standard audience criterion. */
  removeAllStandardQualification?: Maybe<Array<DraftStandardQualification>>;
  removeAudienceMemberMetadata?: Maybe<DraftFieldworkAudienceMember>;
  /** Removes a specific candidate audience from the list. */
  removeCandidateAudience?: Maybe<Scalars['Unit']['output']>;
  /** An AudienceMarkupGroup denotes a collection of standard criteria where when any of them are added to an audience results in an additional markup being included in the calculation of the cost quote.. This operation remove an existing criterion from a given markup group. */
  removeCriteriaFromGroup?: Maybe<Scalars['Unit']['output']>;
  /** A custom criterion is an audience dimension that Focaldata manage internally (e.g. 'Have you heard of Focaldata?'), without involvement of our panel provider.. This operation renders an existing custom criterion inactive (i.e. is not included in the audience). */
  removeCustomCriterion?: Maybe<DraftCustomCriterion>;
  /** A custom criterion is an audience dimension that Focaldata manage internally (e.g. 'Have you heard of Focaldata?'), without involvement of our panel provider.. This operation removes the media for an existing custom criterion option. */
  removeCustomCriterionOptionMedia?: Maybe<DraftCustomAudienceCriterionOption>;
  removeCustomCriterionOptionMetadata?: Maybe<Scalars['Unit']['output']>;
  removeCustomCriterionOptionsLogic?: Maybe<DraftFieldworkAudienceMember>;
  /** Settings modify the behaviour of an audience member. This operation removes a setting from a given custom audience member. */
  removeCustomMemberSettingValue?: Maybe<MemberSettingValue>;
  /** A respondent who chooses an option that does not have a qualification set on it will be screened out of the survey. This operation removes the qualification from a given custom audience criterion option. */
  removeCustomQualification?: Maybe<DraftQualification>;
  /** Preset audiences are defined by FD internally to allow convenient set-up of the most common audiences (e.g. Nat Rep). This operation removes a preset audience from the list of available ones. */
  removePresetAudience?: Maybe<Scalars['Unit']['output']>;
  /** A custom criterion is an audience dimension that Focaldata manage internally (e.g. 'Have you heard of Focaldata?'), without involvement of our panel provider. This operation removes an existing criterion to an audience. */
  removeStandardCriterion?: Maybe<StandardCriterion>;
  removeStandardCriterionOptionMetadata?: Maybe<Scalars['Unit']['output']>;
  /** Settings modify the behaviour of audience members. This operation removes a setting from a specific audience member. */
  removeStandardMemberSettingValue?: Maybe<MemberSettingValue>;
  /** A respondent who chooses an option that does not have a qualification set on it will be screened out of the survey. This operation removes the qualification from a given standard audience criterion option. */
  removeStandardQualification?: Maybe<DraftStandardQualification>;
  /** An option that has a quota of x% set on it requires that x% of respondents choose this option. This operation disables quotas on a particular standard audience criterion. */
  removeStandardQuotas?: Maybe<DraftFieldworkAudienceMember>;
  /** Attach a new candidate audience to a survey. The new audience is appended to the list of existing ones. */
  saveCandidateAudience?: Maybe<CandidateAudience>;
  /** A respondent who chooses an option that does not have a qualification set on it will be screened out of the survey. This operation sets all options on a standard audience criterion as being qualifying. */
  setAllStandardQualification?: Maybe<Array<DraftStandardQualification>>;
  /** A custom criterion is an audience dimension that Focaldata manage internally (e.g. 'Have you heard of Focaldata?'), without involvement of our panel provider.. This operation renders an existing custom criterion active (i.e. is included in the audience). */
  setCustomCriterion?: Maybe<DraftCustomCriterion>;
  /** A custom criterion is an audience dimension that Focaldata manage internally (e.g. 'Have you heard of Focaldata?'), without involvement of our panel provider.. This operation sets media for an existing custom criterion option. */
  setCustomCriterionOptionMedia?: Maybe<DraftCustomAudienceCriterionOption>;
  setCustomCriterionOptionsLogic?: Maybe<DraftFieldworkAudienceMember>;
  /** Settings modify the behaviour of an audience member. This operation adds a setting to a given custom audience member. */
  setCustomMemberSettingValue?: Maybe<MemberSettingValue>;
  /** A respondent who chooses an option that does not have a qualification set on it will be screened out of the survey. This operation sets a particular custom audience criterion option as being qualifying. */
  setCustomQualification?: Maybe<DraftQualification>;
  /** An option that has a quota of x% set on it requires that x% of respondents choose this option. This operation sets the quota for a particular custom criterion option. */
  setCustomQuota?: Maybe<DraftQuota>;
  /** Exclusive options cannot be chosen alongside other options on the same question. */
  setExclusiveResponseOption?: Maybe<DraftCustomAudienceCriterionOption>;
  /** Preset audiences are defined by FD internally to allow convenient set-up of the most common audiences (e.g. Nat Rep). This operation replaces the current audience with the chosen preset audience. */
  setPresetAudience?: Maybe<Scalars['Unit']['output']>;
  /** A standard criterion maps onto one of the available audience dimensions (e.g. 'What is your age?') provided by one of our panel providers (e.g. Cint).. This operation adds a new criterion to an audience. */
  setStandardCriterion?: Maybe<StandardCriterion>;
  /** Settings modify the behaviour of audience members. This operation adds a new setting to a specific audience member. */
  setStandardMemberSettingValue?: Maybe<MemberSettingValue>;
  /** A respondent who chooses an option that does not have a qualification set on it will be screened out of the survey. This operation sets a particular standard audience criterion option as being qualifying. */
  setStandardQualification?: Maybe<DraftStandardQualification>;
  /** An option that has a quota of x% set on it requires that x% of respondents choose this option. This operation sets the quota for a particular standard criterion option. */
  setStandardQuota?: Maybe<Quota>;
  /** An option that has a quota of x% set on it requires that x% of respondents choose this option. This operation enables quotas on a particular standard audience criterion. */
  setStandardQuotas?: Maybe<DraftFieldworkAudienceMember>;
  /** Update the feasibility threshold to make the feasibility check more or less permissive. */
  setThreshold?: Maybe<Scalars['Float']['output']>;
  /** A custom criterion is an audience dimension that Focaldata manage internally (e.g. 'Have you heard of Focaldata?'), without involvement of our panel provider.. This operation updates the text of an existing custom criterion. */
  updateCustomCriterion?: Maybe<DraftFieldworkAudienceMember>;
  /** A custom criterion option is a possible answer to a custom criterion (e.g. 'Yes' or 'No').. This operation updates the text of an existing custom criterion option. */
  updateCustomCriterionOption?: Maybe<DraftCustomAudienceCriterionOption>;
  /** Customized standard options are standard criteria with user-defined behaviour. For example, custom age-bands. This operation updates a given customized option on a standard audience criterion. */
  updateCustomizedCriterionOption?: Maybe<DraftFieldworkAudienceMember>;
  /** Update the configuration of a given fieldwork. */
  updateFieldwork?: Maybe<Scalars['Unit']['output']>;
  /** An AudienceMarkupGroup denotes a collection of standard criteria where when any of them are added to an audience results in an additional markup being included in the calculation of the cost quote.. This operation updates the markup for a given group. */
  updateMarkupForGroup?: Maybe<Scalars['Unit']['output']>;
  /** Preset audiences are defined by FD internally to allow convenient set-up of the most common audiences (e.g. Nat Rep). This operation amends an existing preset audience. */
  updatePresetAudience?: Maybe<PresetAudienceGql>;
};


export type ConfigMutationsAddAudienceMemberMetadataArgs = {
  metadata?: InputMaybe<Scalars['Json']['input']>;
  number: Scalars['Int']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsAddCustomCriterionArgs = {
  areOptionsQualifying?: InputMaybe<Scalars['Boolean']['input']>;
  defaultOptionsCount?: InputMaybe<Scalars['Int']['input']>;
  defaultOptionsResponseIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  defaultQuestionId?: InputMaybe<Scalars['ID']['input']>;
  position: Scalars['Int']['input'];
  setting?: InputMaybe<SettingInputInput>;
  settings?: InputMaybe<Array<SettingInputInput>>;
  surveyId: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};


export type ConfigMutationsAddCustomCriterionOptionArgs = {
  defaultResponseOptionId?: InputMaybe<Scalars['ID']['input']>;
  isOptionQualifying?: InputMaybe<Scalars['Boolean']['input']>;
  position: Scalars['Int']['input'];
  questionLk: Scalars['ID']['input'];
  responseOption?: InputMaybe<ResponseOptionInputInput>;
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsAddCustomCriterionOptionMetadataArgs = {
  metadata: Scalars['Json']['input'];
  questionLk: Scalars['ID']['input'];
  responseOptionLk: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsAddCustomizedCriterionOptionArgs = {
  criterion: Scalars['String']['input'];
  criterionOptions: Array<CustomizedCriterionOptionInput>;
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsAddFieldworkArgs = {
  accountMarkup?: InputMaybe<Scalars['Float']['input']>;
  audienceDescription?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  countryLanguage?: InputMaybe<Scalars['String']['input']>;
  panelSupplierCode: Scalars['String']['input'];
  samplesNeeded: Scalars['Int']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsAddOrUpdatePanelistPoolArgs = {
  panelistIds: Array<Scalars['String']['input']>;
  poolType: PanelistPoolType;
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsAddPresetAudienceArgs = {
  incidenceRate: Scalars['Int']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  locale: LocaleInput;
  members: Array<DraftFieldworkAudienceMemberInputInput>;
  name: Scalars['String']['input'];
};


export type ConfigMutationsAddStandardCriterionOptionMetadataArgs = {
  audienceCriterionCode: Scalars['String']['input'];
  audienceCriterionOptionCode: Scalars['String']['input'];
  metadata: Scalars['Json']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsAddorUpdateDedupeTagsArgs = {
  dedupeTags: Array<Scalars['String']['input']>;
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsAddorUpdatePostcodeTargetArgs = {
  postcodes: Array<Scalars['String']['input']>;
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsAppendCriteriaToGroupArgs = {
  criterions: Array<AudienceCriterionPairInput>;
  groupName: Scalars['String']['input'];
};


export type ConfigMutationsClearFeasibilityCacheArgs = {
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};


export type ConfigMutationsCreateMarkupCriteriaGroupArgs = {
  groupName: Scalars['String']['input'];
  markup: Scalars['Float']['input'];
};


export type ConfigMutationsDeleteMarkupCriteriaGroupArgs = {
  groupName: Scalars['String']['input'];
};


export type ConfigMutationsDetachCustomAudienceMemberArgs = {
  number: Scalars['Int']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsDetachCustomCriterionOptionArgs = {
  questionLk: Scalars['ID']['input'];
  responseOptionLk: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsDetachCustomizedCriterionOptionArgs = {
  criterion: Scalars['String']['input'];
  responseOptionId: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsDuplicateFieldworkAudienceArgs = {
  newSurveyId: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsDuplicatePresetAudienceArgs = {
  locale: LocaleInput;
  position: Scalars['Int']['input'];
  presetAudienceId: Scalars['ID']['input'];
};


export type ConfigMutationsEmptyAudienceCriterionArgs = {
  questionLk: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsMakeSurveyFeasibleArgs = {
  estimatedDeliveryTime?: InputMaybe<Scalars['Int']['input']>;
  feasibility?: InputMaybe<Scalars['Float']['input']>;
  isFeasible?: InputMaybe<Scalars['Boolean']['input']>;
  loi: Scalars['Int']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsMoveAudienceMemberArgs = {
  number: Scalars['Int']['input'];
  surveyId: Scalars['ID']['input'];
  toPosition: Scalars['Int']['input'];
};


export type ConfigMutationsMoveCustomCriterionOptionArgs = {
  questionLk: Scalars['ID']['input'];
  responseOptionLk: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
  toPosition: Scalars['Int']['input'];
};


export type ConfigMutationsMovePresetAudienceArgs = {
  locale: LocaleInput;
  presetAudienceId: Scalars['ID']['input'];
  toPosition: Scalars['Int']['input'];
};


export type ConfigMutationsPasteInAudienceTitleArgs = {
  questionLk: Scalars['ID']['input'];
  responseOptions: Array<Scalars['String']['input']>;
  surveyId: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};


export type ConfigMutationsPasteInCriterionOptionsArgs = {
  questionLk: Scalars['ID']['input'];
  responseOptions: Array<Scalars['String']['input']>;
  startPosition: Scalars['Int']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsPinOrUnpinResponseOptionArgs = {
  pinned: Scalars['Boolean']['input'];
  questionLk: Scalars['ID']['input'];
  responseOptionLk: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsPresetAudienceArgs = {
  name: Scalars['String']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsRemoveAllStandardQualificationArgs = {
  audienceCriterionCode: Scalars['String']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsRemoveAudienceMemberMetadataArgs = {
  number: Scalars['Int']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsRemoveCandidateAudienceArgs = {
  candidateAudienceNumber: Scalars['Int']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsRemoveCriteriaFromGroupArgs = {
  criterions: AudienceCriterionPairInput;
  groupName: Scalars['String']['input'];
};


export type ConfigMutationsRemoveCustomCriterionArgs = {
  criterionState?: InputMaybe<AudienceCriterionState>;
  questionLk: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsRemoveCustomCriterionOptionMediaArgs = {
  questionLk: Scalars['ID']['input'];
  responseOptionLk: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsRemoveCustomCriterionOptionMetadataArgs = {
  questionLk: Scalars['ID']['input'];
  responseOptionLk: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsRemoveCustomCriterionOptionsLogicArgs = {
  questionLk: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsRemoveCustomMemberSettingValueArgs = {
  memberSettingCode: Scalars['String']['input'];
  questionLk: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsRemoveCustomQualificationArgs = {
  questionLk: Scalars['ID']['input'];
  responseOptionLk: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsRemovePresetAudienceArgs = {
  locale: LocaleInput;
  presetAudienceId: Scalars['ID']['input'];
};


export type ConfigMutationsRemoveStandardCriterionArgs = {
  audienceCriterionCode: Scalars['String']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsRemoveStandardCriterionOptionMetadataArgs = {
  audienceCriterionCode: Scalars['String']['input'];
  audienceCriterionOptionCode: Scalars['String']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsRemoveStandardMemberSettingValueArgs = {
  audienceCriterionCode: Scalars['String']['input'];
  memberSettingCode: Scalars['String']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsRemoveStandardQualificationArgs = {
  audienceCriterionCode: Scalars['String']['input'];
  audienceCriterionOptionCode: Scalars['String']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsRemoveStandardQuotasArgs = {
  audienceCriterionCode: Scalars['String']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsSaveCandidateAudienceArgs = {
  candidateAudience: CandidateAudienceInput;
};


export type ConfigMutationsSetAllStandardQualificationArgs = {
  audienceCriterionCode: Scalars['String']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsSetCustomCriterionArgs = {
  criterionState?: InputMaybe<AudienceCriterionState>;
  questionLk: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsSetCustomCriterionOptionMediaArgs = {
  mediaName: Scalars['String']['input'];
  mediaType: MediaType;
  mediaUrl: Scalars['String']['input'];
  questionLk: Scalars['ID']['input'];
  renderedMediaUrl?: InputMaybe<Scalars['String']['input']>;
  responseOptionLk: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsSetCustomCriterionOptionsLogicArgs = {
  exemptResponseOptionLks?: InputMaybe<Array<Scalars['ID']['input']>>;
  loopQuotaPriority?: InputMaybe<LoopQuotaPriorityInputInput>;
  maxResponseOptionsToDisplay?: InputMaybe<Scalars['Int']['input']>;
  questionLk: Scalars['ID']['input'];
  setAsRandomised?: InputMaybe<Scalars['Boolean']['input']>;
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsSetCustomMemberSettingValueArgs = {
  questionLk: Scalars['ID']['input'];
  setting: SettingInputInput;
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsSetCustomQualificationArgs = {
  questionLk: Scalars['ID']['input'];
  responseOptionLk: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsSetCustomQuotaArgs = {
  percent: Scalars['Float']['input'];
  questionLk: Scalars['ID']['input'];
  responseOptionLk: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsSetExclusiveResponseOptionArgs = {
  exclusive: Scalars['Boolean']['input'];
  questionLk: Scalars['ID']['input'];
  responseOptionLk: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsSetPresetAudienceArgs = {
  presetAudienceId: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsSetStandardCriterionArgs = {
  audienceCriterionCode: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsSetStandardMemberSettingValueArgs = {
  audienceCriterionCode: Scalars['String']['input'];
  setting: SettingInputInput;
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsSetStandardQualificationArgs = {
  audienceCriterionCode: Scalars['String']['input'];
  audienceCriterionOptionCode: Scalars['String']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsSetStandardQuotaArgs = {
  audienceCriterionCode: Scalars['String']['input'];
  audienceCriterionOptionCode: Scalars['String']['input'];
  percent: Scalars['Float']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsSetStandardQuotasArgs = {
  audienceCriterionCode: Scalars['String']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsSetThresholdArgs = {
  value: Scalars['Float']['input'];
};


export type ConfigMutationsUpdateCustomCriterionArgs = {
  questionLk: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};


export type ConfigMutationsUpdateCustomCriterionOptionArgs = {
  questionLk: Scalars['ID']['input'];
  responseOption?: InputMaybe<ResponseOptionInputInput>;
  responseOptionLk: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsUpdateCustomizedCriterionOptionArgs = {
  criterion: Scalars['String']['input'];
  criterionOption: CustomizedCriterionOptionInput;
  responseOptionId: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsUpdateFieldworkArgs = {
  audienceDescription?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryLanguage?: InputMaybe<Scalars['String']['input']>;
  currentPresetAudience?: InputMaybe<Scalars['String']['input']>;
  customEstimatedLoi?: InputMaybe<CustomEstimatedLoiInputInput>;
  endDate?: InputMaybe<Scalars['Instant']['input']>;
  incidenceRate?: InputMaybe<Scalars['Int']['input']>;
  lengthOfInterview?: InputMaybe<Scalars['Int']['input']>;
  monitorDifficultQuotas?: InputMaybe<Scalars['Boolean']['input']>;
  panelSupplierCode: Scalars['String']['input'];
  prolificFilters?: InputMaybe<Scalars['Json']['input']>;
  samplesNeeded?: InputMaybe<Scalars['Int']['input']>;
  softLaunch?: InputMaybe<SoftLaunchInput>;
  startDate?: InputMaybe<Scalars['Instant']['input']>;
  surveyId: Scalars['ID']['input'];
};


export type ConfigMutationsUpdateMarkupForGroupArgs = {
  groupName: Scalars['String']['input'];
  markup: Scalars['Float']['input'];
};


export type ConfigMutationsUpdatePresetAudienceArgs = {
  presetAudience: PresetAudienceInputInput;
};

export type ConfigQueries = {
  __typename?: 'ConfigQueries';
  audienceMemberSettings: MemberSettings;
  /** A 'candidate audience' is an audience specified by one of the FD team which gets used to enrich the basic fieldwork audience in order to expedite fieldwork. A particular survey may have multiple candidate audiences added to it. */
  candidateAudiences?: Maybe<Array<CandidateAudience>>;
  /** A category is a group of thematically co-related criteria (e.g. 'Demographics', 'Lifestyle', 'Media', etc.) */
  categories?: Maybe<Array<FieldworkAudienceCategory>>;
  /** Fetch categories available for a particular country. */
  categoriesByLocale?: Maybe<Array<FieldworkAudienceCategory>>;
  /** Return the JSON representation of the standard audience, according to the requirements of the Cint API */
  cintQuotaGroupsJson?: Maybe<Scalars['Json']['output']>;
  /** Countries FD support running surveys in. */
  countries: Array<Country>;
  /** Custom criteria are any of the bespoke audience screeners added by the user. */
  customCriteria?: Maybe<Array<DraftCustomCriterion>>;
  /** The draft audience is the audience that the user interacts with as they construct it. */
  draftAudience?: Maybe<DraftFieldworkAudience>;
  /** The basic fieldwork configuration for a given survey. */
  fieldwork?: Maybe<Fieldwork>;
  /** The fieldwork audience is the finalised one that is consumed by the rest of the system once the project goes live. */
  fieldworkAudience?: Maybe<FieldworkAudience>;
  /** An AudienceMarkupGroup denotes a collection of standard criteria where when any of them are added to an audience results in an additional markup being included in the calculation of the cost quote.. This operation returns all active markup groups. */
  getAllMarkupGroups?: Maybe<Array<AudienceMarkupGroup>>;
  /** Return an cost-per-interview (CPI) estimate for a particular survey. */
  getCostQuote?: Maybe<CostQuote>;
  /** Return the currently cached feasibility value for a particular survey. This service uses an in-memory cache to store most up-to-date feasibility score. */
  getFeasibilityCache?: Maybe<Scalars['String']['output']>;
  /** Return a feasibility estimate for a particular survey. This results in a call to the Cint API. You can read more about how Cint handle feasibility in their API documentation. */
  getFeasibilityEstimate?: Maybe<FeasibilityEstimate>;
  /** An AudienceMarkupGroup denotes a collection of standard criteria where when any of them are added to an audience results in an additional markup being included in the calculation of the cost quote.. TODO: Ask Shailen. */
  getMarkupForCriterions?: Maybe<Scalars['Float']['output']>;
  /** An AudienceMarkupGroup denotes a collection of standard criteria where when any of them are added to an audience results in an additional markup being included in the calculation of the cost quote.. This operation return a given markup group by name. */
  getMarkupGroup?: Maybe<AudienceMarkupGroup>;
  /** Preset audiences are defined by FD internally to allow convenient set-up of the most common audiences (e.g. Nat Rep).. This operation returns all available preset audiences for this locale. */
  getPresetAudiences?: Maybe<Array<PresetAudienceGql>>;
  /** Return the current value of the feasibility threshold. */
  getThreshold: Scalars['Float']['output'];
  /** @deprecated This operation has been deprecated, please use the other preset audience query to interact with preset audiences. */
  presetAudiences?: Maybe<Array<LegacyPresetAudience>>;
  /** Return available categories / criteria / options with text matching a particular string. */
  searchCategories?: Maybe<Array<FieldworkAudienceCategoryWithOptions>>;
  /** Return available categories / criteria / options with text matching a particular string, in a particular locale. */
  searchCategoriesByLocale?: Maybe<Array<FieldworkAudienceCategoryWithOptions>>;
};


export type ConfigQueriesAudienceMemberSettingsArgs = {
  memberTypeCode: Scalars['String']['input'];
};


export type ConfigQueriesCandidateAudiencesArgs = {
  surveyId: Scalars['ID']['input'];
};


export type ConfigQueriesCategoriesArgs = {
  expandedCategories: Array<Scalars['String']['input']>;
  surveyId: Scalars['ID']['input'];
};


export type ConfigQueriesCategoriesByLocaleArgs = {
  expandedCategories: Array<Scalars['String']['input']>;
  locale: LocaleInput;
};


export type ConfigQueriesCintQuotaGroupsJsonArgs = {
  candidateAudienceRank?: InputMaybe<Scalars['Int']['input']>;
  collapseQuotas?: InputMaybe<Scalars['Boolean']['input']>;
  interlockQuotas?: InputMaybe<Scalars['Boolean']['input']>;
  newLimit?: InputMaybe<Scalars['Int']['input']>;
  overrideQuotas?: InputMaybe<Array<StagnantQuotaInput>>;
  quotaKeys?: InputMaybe<Array<Array<QuotaKeyInput>>>;
  surveyId: Scalars['ID']['input'];
  targetPostcodes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type ConfigQueriesCustomCriteriaArgs = {
  surveyId: Scalars['ID']['input'];
};


export type ConfigQueriesDraftAudienceArgs = {
  surveyId: Scalars['ID']['input'];
};


export type ConfigQueriesFieldworkArgs = {
  softlaunch?: InputMaybe<Scalars['Boolean']['input']>;
  surveyId: Scalars['ID']['input'];
};


export type ConfigQueriesFieldworkAudienceArgs = {
  collapseCustomQuotas?: InputMaybe<Scalars['Boolean']['input']>;
  collapseQuotas?: InputMaybe<Scalars['Boolean']['input']>;
  collapseStandardQuotas?: InputMaybe<Scalars['Boolean']['input']>;
  interlockQuotas?: InputMaybe<Scalars['Boolean']['input']>;
  surveyId: Scalars['ID']['input'];
};


export type ConfigQueriesGetCostQuoteArgs = {
  loi?: InputMaybe<Scalars['Int']['input']>;
  surveyId: Scalars['ID']['input'];
};


export type ConfigQueriesGetFeasibilityCacheArgs = {
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};


export type ConfigQueriesGetFeasibilityEstimateArgs = {
  loi?: InputMaybe<Scalars['Int']['input']>;
  recalculate?: InputMaybe<Scalars['Boolean']['input']>;
  surveyId: Scalars['ID']['input'];
};


export type ConfigQueriesGetMarkupForCriterionsArgs = {
  criterions: Array<Scalars['String']['input']>;
  options: Array<Scalars['String']['input']>;
};


export type ConfigQueriesGetMarkupGroupArgs = {
  groupName: Scalars['String']['input'];
};


export type ConfigQueriesGetPresetAudiencesArgs = {
  locale: LocaleInput;
};


export type ConfigQueriesGetThresholdArgs = {
  value: Scalars['Unit']['input'];
};


export type ConfigQueriesPresetAudiencesArgs = {
  countryCode: Scalars['String']['input'];
};


export type ConfigQueriesSearchCategoriesArgs = {
  searchCriteria: Scalars['String']['input'];
  surveyId: Scalars['ID']['input'];
};


export type ConfigQueriesSearchCategoriesByLocaleArgs = {
  locale: LocaleInput;
  searchCriteria: Scalars['String']['input'];
};

export type CostMarkup = {
  __typename?: 'CostMarkup';
  account: Scalars['Float']['output'];
  audience: Scalars['Float']['output'];
  base: Scalars['Float']['output'];
  country: Scalars['Float']['output'];
};

export type CostPerInterview = {
  __typename?: 'CostPerInterview';
  amount: Scalars['Float']['output'];
  baseAmount: Scalars['Float']['output'];
  currency: Scalars['String']['output'];
};

export type CostQuote = {
  __typename?: 'CostQuote';
  cpi: CostPerInterview;
};

export type Country = {
  __typename?: 'Country';
  countryCode: Scalars['String']['output'];
  languageName: Scalars['String']['output'];
  locale: Locale;
  name: Scalars['String']['output'];
};

export type CriterionValidationErrors = CustomCriterionValidationErrors | StandardCriterionValidationErrors;

export type CustomAudience = {
  __typename?: 'CustomAudience';
  countryId: Scalars['Int']['output'];
  description: Scalars['String']['output'];
};

export type CustomAudienceCriterionOption = {
  __typename?: 'CustomAudienceCriterionOption';
  position: Scalars['Int']['output'];
  qualification?: Maybe<Qualification>;
  quota?: Maybe<Quota>;
  responseOption: ResponseOption;
  weight?: Maybe<Weight>;
};

export type CustomAudienceItem = {
  __typename?: 'CustomAudienceItem';
  createdDate: Scalars['Instant']['output'];
  customCriterionOptions: Array<CustomAudienceCriterionOption>;
  question?: Maybe<Question>;
  settingValues: Array<MemberSettingValue>;
  sinceDate: Scalars['Instant']['output'];
};

export type CustomCriterionOptionValidationErrors = {
  __typename?: 'CustomCriterionOptionValidationErrors';
  errors: Array<CustomOptionValidationError>;
  responseOptionLk: Scalars['ID']['output'];
};

export enum CustomCriterionValidationError {
  EmptyTextError = 'EmptyTextError',
  InvalidCustomQuotaSumError = 'InvalidCustomQuotaSumError',
  InvalidDisplayLogicSourceError = 'InvalidDisplayLogicSourceError',
  InvalidResponseOptionsToDisplayError = 'InvalidResponseOptionsToDisplayError',
  MissingCustomQualificationError = 'MissingCustomQualificationError',
  MissingCustomQualifyingSettingWarning = 'MissingCustomQualifyingSettingWarning',
  MissingCustomQuotasSettingWarning = 'MissingCustomQuotasSettingWarning',
  OptionCountLessThan2Error = 'OptionCountLessThan2Error',
  SectionNotFoundError = 'SectionNotFoundError'
}

export type CustomCriterionValidationErrors = {
  __typename?: 'CustomCriterionValidationErrors';
  customCriterionOptionsErrors: Array<CustomCriterionOptionValidationErrors>;
  errors: Array<CustomCriterionValidationError>;
  questionLk: Scalars['ID']['output'];
};

export type CustomEstimatedLoiInputInput = {
  /** Set this field to true to remove a custom estimated loi. Do not with CustomEstimatedLoiInput */
  clearValue: Scalars['Boolean']['input'];
  /** Set this field to set a custom estimated loi. Do not use with clearValue */
  value?: InputMaybe<Scalars['Int']['input']>;
};

export enum CustomOptionValidationError {
  CustomQuotaIsZeroError = 'CustomQuotaIsZeroError',
  EmptyValueError = 'EmptyValueError',
  ResponseOptionNotExemptOrMappedError = 'ResponseOptionNotExemptOrMappedError'
}

export type CustomizedCriterionOptionInput = {
  criterionOptionCode: Scalars['String']['input'];
  qualification?: InputMaybe<QualificationInput>;
  quota?: InputMaybe<QuotaInput>;
  weight?: InputMaybe<WeightInput>;
};

export type DetachedCustomAudienceMember = {
  __typename?: 'DetachedCustomAudienceMember';
  detachedDate: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  surveyId: Scalars['ID']['output'];
};

export type DetachedCustomCriterionOption = {
  __typename?: 'DetachedCustomCriterionOption';
  detachedDate: Scalars['String']['output'];
  questionLk: Scalars['ID']['output'];
  responseOptionLk: Scalars['ID']['output'];
  surveyId: Scalars['ID']['output'];
};

export type DraftCustomAudienceCriterionOption = {
  __typename?: 'DraftCustomAudienceCriterionOption';
  createdDate: Scalars['String']['output'];
  exclusive?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<ResponseOptionMedia>;
  metadata?: Maybe<Scalars['Json']['output']>;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  position: Scalars['Int']['output'];
  qualification?: Maybe<Qualification>;
  quota?: Maybe<Quota>;
  responseOption?: Maybe<ResponseOption>;
  responseOptionLk: Scalars['ID']['output'];
  responseOptionLocalisations?: Maybe<Array<LocalisedResponseOption>>;
  sinceDate: Scalars['String']['output'];
  weight?: Maybe<Weight>;
};

export type DraftCustomAudienceCriterionOptionInput = {
  createdDate: Scalars['String']['input'];
  exclusive?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<ResponseOptionMediaInput>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  position: Scalars['Int']['input'];
  qualification?: InputMaybe<QualificationInput>;
  quota?: InputMaybe<QuotaInput>;
  responseOption?: InputMaybe<ResponseOptionInput>;
  responseOptionLk: Scalars['ID']['input'];
  responseOptionLocalisations?: InputMaybe<Array<LocalisedResponseOptionInput>>;
  sinceDate: Scalars['String']['input'];
  weight?: InputMaybe<WeightInput>;
};

export type DraftCustomAudienceItem = {
  __typename?: 'DraftCustomAudienceItem';
  createdDate: Scalars['String']['output'];
  criterionOptions: Array<DraftCustomAudienceCriterionOption>;
  question?: Maybe<Question>;
  questionLk: Scalars['ID']['output'];
  questionLocalisations?: Maybe<Array<LocalisedQuestion>>;
  responseOptionsLogic?: Maybe<ResponseOptionsLogic>;
  settingValues: Array<MemberSettingValue>;
  sinceDate: Scalars['String']['output'];
  state: AudienceCriterionState;
};

export type DraftCustomAudienceItemInputInput = {
  createdDate: Scalars['String']['input'];
  criterionOptions: Array<DraftCustomAudienceCriterionOptionInput>;
  question?: InputMaybe<QuestionInput>;
  questionLk: Scalars['ID']['input'];
  settingValues: Array<MemberSettingValueInput>;
  sinceDate: Scalars['String']['input'];
  state: AudienceCriterionState;
};

export type DraftCustomCriterion = {
  __typename?: 'DraftCustomCriterion';
  createdDate: Scalars['String']['output'];
  number: Scalars['Int']['output'];
  question?: Maybe<Question>;
  questionLk: Scalars['ID']['output'];
  sinceDate: Scalars['String']['output'];
  state: AudienceCriterionState;
};

export type DraftFieldworkAudience = {
  __typename?: 'DraftFieldworkAudience';
  createdDate: Scalars['String']['output'];
  members: Array<DraftFieldworkAudienceMember>;
  sinceDate: Scalars['String']['output'];
  surveyId: Scalars['ID']['output'];
  validationErrors: Array<CriterionValidationErrors>;
};

/** A DraftFieldworkAudienceMember */
export type DraftFieldworkAudienceMember = {
  __typename?: 'DraftFieldworkAudienceMember';
  contextPosition: Scalars['Int']['output'];
  isWeighted: Scalars['Boolean']['output'];
  memberItem: DraftMemberItem;
  memberType: MemberType;
  metadata?: Maybe<Scalars['Json']['output']>;
  number: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
};

export type DraftFieldworkAudienceMemberInputInput = {
  contextPosition: Scalars['Int']['input'];
  draftCustomMemberItem?: InputMaybe<DraftCustomAudienceItemInputInput>;
  draftStandardMemberItem?: InputMaybe<DraftStandardAudienceItemInput>;
  memberType: MemberType;
  number: Scalars['Int']['input'];
  position: Scalars['Int']['input'];
};

export type DraftMemberItem = DraftCustomAudienceItem | DraftStandardAudienceItem;

export type DraftQualification = {
  __typename?: 'DraftQualification';
  questionLk: Scalars['ID']['output'];
  responseOptionLk: Scalars['ID']['output'];
  sinceDate: Scalars['String']['output'];
  surveyId: Scalars['ID']['output'];
};

export type DraftQuota = {
  __typename?: 'DraftQuota';
  percent: Scalars['Float']['output'];
  questionLk: Scalars['ID']['output'];
  responseOptionLk: Scalars['ID']['output'];
  sinceDate: Scalars['String']['output'];
  surveyId: Scalars['ID']['output'];
};

export type DraftStandardAudienceItem = {
  __typename?: 'DraftStandardAudienceItem';
  criterion: AudienceCriterion;
  customizedCriterionOptions: Array<StandardAudienceCriterionOption>;
  settingValues: Array<MemberSettingValue>;
  standardCriterionOptions: Array<StandardAudienceCriterionOption>;
};

export type DraftStandardAudienceItemInput = {
  criterion: AudienceCriterionInput;
  customizedCriterionOptions: Array<StandardAudienceCriterionOptionInput>;
  settingValues: Array<MemberSettingValueInput>;
  standardCriterionOptions: Array<StandardAudienceCriterionOptionInput>;
};

export type DraftStandardQualification = {
  __typename?: 'DraftStandardQualification';
  audienceCriterionCode: Scalars['String']['output'];
  audienceCriterionOptionCode: Scalars['String']['output'];
  createDate: Scalars['String']['output'];
  sinceDate: Scalars['String']['output'];
  surveyId: Scalars['ID']['output'];
};

export enum DraftStatus {
  Drafting = 'Drafting',
  Valid = 'Valid'
}

export type Duration = {
  __typename?: 'Duration';
  endDate: Scalars['Instant']['output'];
  startDate: Scalars['Instant']['output'];
};

export type EntryItem = ForkItem | MatrixItem | QuestionItem | SectionItem | TextCardItem;

export type EntryResponseOption = {
  __typename?: 'EntryResponseOption';
  createdDate: Scalars['String']['output'];
  exclusive?: Maybe<Scalars['Boolean']['output']>;
  maskingRules: Array<MaskingRule>;
  media?: Maybe<ResponseOptionMedia>;
  metadata?: Maybe<Scalars['Json']['output']>;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  position: Scalars['Int']['output'];
  qualification?: Maybe<Qualification>;
  responseOption: LocalisedResponseOption;
  route?: Maybe<Route>;
  sinceDate: Scalars['String']['output'];
  textEntryState: TextEntryState;
};

export type EntrySettingValue = {
  __typename?: 'EntrySettingValue';
  code: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  sinceDate: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum EntryType {
  ForkEntryType = 'ForkEntryType',
  MatrixEntryType = 'MatrixEntryType',
  QuestionEntryType = 'QuestionEntryType',
  SectionEntryType = 'SectionEntryType',
  TextCardEntryType = 'TextCardEntryType'
}

export type ExperimentalDesign = {
  __typename?: 'ExperimentalDesign';
  sets: Array<ResponseOptionSet>;
  version: Scalars['Int']['output'];
};

export type FeasibilityEstimate = {
  __typename?: 'FeasibilityEstimate';
  errors: Array<CintError>;
  estimatedDeliveryTime?: Maybe<Scalars['Int']['output']>;
  feasibility: Scalars['Float']['output'];
  infeasibleQuotas: Array<InfeasibleQuota>;
  isFeasible: Scalars['Boolean']['output'];
  pollingMessage?: Maybe<Scalars['String']['output']>;
  pollingStatus?: Maybe<Scalars['String']['output']>;
};

export type Fieldwork = {
  __typename?: 'Fieldwork';
  activePresetAudience?: Maybe<Scalars['String']['output']>;
  apiVersion: Scalars['String']['output'];
  audience: Array<PanelSupplierAudience>;
  createdDate: Scalars['Instant']['output'];
  customEstimatedLoi?: Maybe<Scalars['Int']['output']>;
  duration: Duration;
  hasPII: Scalars['Boolean']['output'];
  incidenceRate: Scalars['Int']['output'];
  isConfiguredForSoftLaunch: Scalars['Boolean']['output'];
  lengthOfInterview: LengthOfInterview;
  locale: Locale;
  markup: CostMarkup;
  monitorDifficultQuotas?: Maybe<Scalars['Boolean']['output']>;
  presetAudience?: Maybe<ActivePresetAudience>;
  projectId?: Maybe<Scalars['ID']['output']>;
  samplesNeeded: SamplesNeeded;
  sinceDate: Scalars['Instant']['output'];
  softLaunch?: Maybe<SoftLaunch>;
  surveyId: Scalars['ID']['output'];
};

export type FieldworkAudience = {
  __typename?: 'FieldworkAudience';
  createdDate: Scalars['String']['output'];
  entries: Array<QuestionnaireEntry>;
  locale: Locale;
  quotas: Array<FieldworkQuota>;
  samplesNeeded?: Maybe<Scalars['Int']['output']>;
  sinceDate: Scalars['String']['output'];
  status: DraftStatus;
  surveyId: Scalars['ID']['output'];
  targetingIds?: Maybe<Array<QuestionTargetingIds>>;
  weights: Array<FieldworkWeight>;
};

export type FieldworkAudienceCategory = {
  __typename?: 'FieldworkAudienceCategory';
  category: AudienceCategory;
  position: Scalars['Int']['output'];
  standardCriteria: Array<StandardCriterion>;
};

export type FieldworkAudienceCategoryWithOptions = {
  __typename?: 'FieldworkAudienceCategoryWithOptions';
  category: AudienceCategory;
  position: Scalars['Int']['output'];
  standardCriteria: StandardCriterionWithOptions;
};

export type FieldworkAudienceMember = {
  __typename?: 'FieldworkAudienceMember';
  memberItem: MemberItem;
  memberType: MemberType;
  metadata?: Maybe<Scalars['Json']['output']>;
  number: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
};

export type FieldworkQuota = {
  __typename?: 'FieldworkQuota';
  createdDate: Scalars['String']['output'];
  isDifficult?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<QuotaKey>;
  keys: Array<QuotaKey>;
  percent: Scalars['Float']['output'];
  respondentCount: Scalars['Float']['output'];
  sinceDate: Scalars['String']['output'];
  surveyId: Scalars['ID']['output'];
};

export type FieldworkWeight = {
  __typename?: 'FieldworkWeight';
  createdDate: Scalars['String']['output'];
  key: WeightKey;
  sinceDate: Scalars['String']['output'];
  surveyId: Scalars['ID']['output'];
  weight: Weight;
};

export type FlatDraftFieldworkAudienceMember = {
  __typename?: 'FlatDraftFieldworkAudienceMember';
  contextPosition: Scalars['Int']['output'];
  draftCustomMemberItem?: Maybe<DraftCustomAudienceItem>;
  draftStandardMemberItem?: Maybe<DraftStandardAudienceItem>;
  isWeighted: Scalars['Boolean']['output'];
  memberType: MemberType;
  number: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
};

export type Fork = {
  __typename?: 'Fork';
  branches: Array<ForkBranch>;
  createdDate: Scalars['String']['output'];
  forkId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sinceDate: Scalars['String']['output'];
};

export type ForkBranch = {
  __typename?: 'ForkBranch';
  branchNumber: Scalars['Int']['output'];
  createdDate: Scalars['String']['output'];
  label: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  sinceDate: Scalars['String']['output'];
};

export type ForkItem = {
  __typename?: 'ForkItem';
  fork: Fork;
};

export type ForkTag = {
  __typename?: 'ForkTag';
  branchNumber: Scalars['Int']['output'];
  forkId: Scalars['ID']['output'];
};

/** An InfeasibleQuota */
export type InfeasibleQuota = {
  __typename?: 'InfeasibleQuota';
  feasibleCounts: Scalars['Int']['output'];
  quota: Scalars['Json']['output'];
};

export type LegacyPresetAudience = {
  __typename?: 'LegacyPresetAudience';
  incidenceRate?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  presetQuestions: Array<PresetQuestion>;
};

export type LengthOfInterview = {
  __typename?: 'LengthOfInterview';
  adjusted: Scalars['Int']['output'];
  unadjusted: Scalars['Int']['output'];
};

export type Locale = {
  __typename?: 'Locale';
  country: Scalars['String']['output'];
  language: Scalars['String']['output'];
};

export type LocaleInput = {
  country: Scalars['String']['input'];
  language: Scalars['String']['input'];
};

export type LocalisedMatrixTitle = {
  __typename?: 'LocalisedMatrixTitle';
  country: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  language: Scalars['String']['output'];
  localisedDate: Scalars['String']['output'];
  matrixTitleId: Scalars['ID']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
  titleStyling?: Maybe<Scalars['String']['output']>;
};

export type LocalisedQuestion = {
  __typename?: 'LocalisedQuestion';
  country: Scalars['String']['output'];
  createdDate: Scalars['Instant']['output'];
  language: Scalars['String']['output'];
  localisedDate: Scalars['Instant']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  questionId: Scalars['ID']['output'];
  questionTypeCode: Scalars['String']['output'];
  text: Scalars['String']['output'];
  textStyling?: Maybe<Scalars['String']['output']>;
};

export type LocalisedQuestionInput = {
  country: Scalars['String']['input'];
  createdDate: Scalars['String']['input'];
  language: Scalars['String']['input'];
  localisedDate: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  questionId: Scalars['ID']['input'];
  questionTypeCode: Scalars['String']['input'];
  text: Scalars['String']['input'];
  textStyling?: InputMaybe<Scalars['String']['input']>;
};

export type LocalisedResponseOption = {
  __typename?: 'LocalisedResponseOption';
  country: Scalars['String']['output'];
  createdDate: Scalars['Instant']['output'];
  language: Scalars['String']['output'];
  localisedDate: Scalars['Instant']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  responseOptionId: Scalars['ID']['output'];
  rotype: ResponseOptionType;
  value: Scalars['String']['output'];
};

export type LocalisedResponseOptionInput = {
  country: Scalars['String']['input'];
  createdDate: Scalars['String']['input'];
  language: Scalars['String']['input'];
  localisedDate: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  responseOptionId: Scalars['ID']['input'];
  rotype: ResponseOptionType;
  value: Scalars['String']['input'];
};

export type LocalisedScaleLabel = {
  __typename?: 'LocalisedScaleLabel';
  country: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  language: Scalars['String']['output'];
  sinceDate: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type LocalisedTextCard = {
  __typename?: 'LocalisedTextCard';
  body: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdDate: Scalars['String']['output'];
  language: Scalars['String']['output'];
  localisedDate: Scalars['String']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  subtitle: Scalars['String']['output'];
  textCardId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  titleStyling?: Maybe<Scalars['String']['output']>;
};

export type LogicClauseProposition = {
  __typename?: 'LogicClauseProposition';
  clause: Scalars['Int']['output'];
  negated: Scalars['Boolean']['output'];
  proposition: LogicProposition;
  propositionType: LogicPropositionType;
};

export type LogicProposition = AudienceReponseOption | MatrixResponseOption | MatrixResponseOptionCount | MatrixRowCount | QuestionResponseOption | QuestionResponseOptionCount | QuestionResponseOptionRank;

export enum LogicPropositionType {
  AudienceResponseOptionType = 'AudienceResponseOptionType',
  MatrixResponseOptionCountType = 'MatrixResponseOptionCountType',
  MatrixResponseOptionType = 'MatrixResponseOptionType',
  MatrixRowCountType = 'MatrixRowCountType',
  QuestionResponseOptionCountType = 'QuestionResponseOptionCountType',
  QuestionResponseOptionRankType = 'QuestionResponseOptionRankType',
  QuestionResponseOptionType = 'QuestionResponseOptionType'
}

export enum LoopBasis {
  Fixed = 'Fixed',
  LeastFilled = 'LeastFilled',
  MostFilled = 'MostFilled',
  Prioritized = 'Prioritized',
  QuotaTarget = 'QuotaTarget',
  Random = 'Random'
}

export type LoopQuotaPriority = {
  __typename?: 'LoopQuotaPriority';
  responseOptionLoopSourcePairs: Array<ResponseOptionLoopSourcePair>;
  sectionId: Scalars['ID']['output'];
};

export type LoopQuotaPriorityInputInput = {
  sectionId: Scalars['ID']['input'];
};

export type LoopSpecificDisplayLogic = {
  __typename?: 'LoopSpecificDisplayLogic';
  entryNumber: Scalars['Int']['output'];
  sourceIds: Array<Scalars['ID']['output']>;
};

export type LoopingConfig = {
  __typename?: 'LoopingConfig';
  loopBasis: LoopBasis;
  loopRandomisationEnabled: Scalars['Boolean']['output'];
  loopSpecificDisplayLogics?: Maybe<Array<LoopSpecificDisplayLogic>>;
  matrixLoopingConfig?: Maybe<MatrixLoopingConfig>;
  maxIterations: Scalars['Int']['output'];
  prioritizedResponseOptionIds?: Maybe<Array<Scalars['ID']['output']>>;
  sourceEntryNumber: Scalars['Int']['output'];
};

export type MaskingKey = {
  __typename?: 'MaskingKey';
  matrixTitleId?: Maybe<Scalars['ID']['output']>;
  questionId: Scalars['ID']['output'];
  responseOptionId: Scalars['ID']['output'];
};

export type MaskingRule = {
  __typename?: 'MaskingRule';
  clause: MaskingRuleClause;
  maskingKeys: Array<MaskingKey>;
  negated?: Maybe<Scalars['Boolean']['output']>;
};

export enum MaskingRuleClause {
  And = 'AND',
  Contains = 'CONTAINS',
  IsOneOf = 'IS_ONE_OF',
  Or = 'OR'
}

export type MatrixItem = {
  __typename?: 'MatrixItem';
  matrixQualification?: Maybe<MatrixQualification>;
  matrixRows: Array<MatrixRow>;
  matrixTitle: LocalisedMatrixTitle;
  questionLogic: Array<Array<LogicClauseProposition>>;
  questionMedia?: Maybe<QuestionMedia>;
  responseOptions: Array<EntryResponseOption>;
  settingValues: Array<EntrySettingValue>;
};

export type MatrixLoopingConfig = {
  __typename?: 'MatrixLoopingConfig';
  qualifyingResponseOptionIds: Array<Scalars['ID']['output']>;
  sourceMatrixRowQuotas: Array<SourceMatrixRowQuota>;
};

export type MatrixQualification = {
  __typename?: 'MatrixQualification';
  matrixRowQualifyingCondition: MatrixRowQualifyingCondition;
  qualifyingOptions: Array<Scalars['ID']['output']>;
};

export type MatrixResponseOption = {
  __typename?: 'MatrixResponseOption';
  matrixTitleId: Scalars['ID']['output'];
  questionId: Scalars['ID']['output'];
  responseOptionId: Scalars['ID']['output'];
};

export type MatrixResponseOptionCount = {
  __typename?: 'MatrixResponseOptionCount';
  count: Scalars['Int']['output'];
  matrixTitleId: Scalars['ID']['output'];
  questionId: Scalars['ID']['output'];
};

export type MatrixRow = {
  __typename?: 'MatrixRow';
  createdDate: Scalars['String']['output'];
  forks?: Maybe<Array<ForkTag>>;
  maskingRules: Array<MaskingRule>;
  metadata?: Maybe<Scalars['Json']['output']>;
  pinned?: Maybe<Scalars['Boolean']['output']>;
  position: Scalars['Int']['output'];
  question: LocalisedQuestion;
  questionMedia?: Maybe<QuestionMedia>;
  sinceDate: Scalars['String']['output'];
};

export type MatrixRowCount = {
  __typename?: 'MatrixRowCount';
  count: Scalars['Int']['output'];
  matrixTitleId: Scalars['ID']['output'];
  responseOptionId: Scalars['ID']['output'];
};

export type MatrixRowQualifyingCondition = {
  __typename?: 'MatrixRowQualifyingCondition';
  numberOfQualifyingRows: Scalars['Int']['output'];
  operator: MatrixRowQualifyingOperator;
};

export enum MatrixRowQualifyingOperator {
  GreaterThanOrEquals = 'GreaterThanOrEquals',
  LessThanOrEquals = 'LessThanOrEquals'
}

export type MaxDiffLocalisedLabel = {
  __typename?: 'MaxDiffLocalisedLabel';
  country: Scalars['String']['output'];
  language: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type MaxDiffSpecification = {
  __typename?: 'MaxDiffSpecification';
  attributeLabel: MaxDiffLocalisedLabel;
  experimentalDesigns?: Maybe<Array<ExperimentalDesign>>;
  leastLabel: MaxDiffLocalisedLabel;
  mostLabel: MaxDiffLocalisedLabel;
};

export enum MediaType {
  Image = 'Image',
  Video = 'Video'
}

export type MemberItem = CustomAudienceItem | StandardAudienceItem;

export type MemberSetting = {
  __typename?: 'MemberSetting';
  createdDate: Scalars['String']['output'];
  dataType: SettingType;
  memberSettingCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  posibleValues: Array<Scalars['String']['output']>;
};

export type MemberSettingValue = {
  __typename?: 'MemberSettingValue';
  code: Scalars['String']['output'];
  createdDate: Scalars['Instant']['output'];
  sinceDate: Scalars['Instant']['output'];
  value: Scalars['String']['output'];
};

export type MemberSettingValueInput = {
  code: Scalars['String']['input'];
  createdDate: Scalars['String']['input'];
  sinceDate: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type MemberSettings = {
  __typename?: 'MemberSettings';
  memberTypeCode: Scalars['String']['output'];
  settings: Array<MemberSetting>;
};

export enum MemberType {
  Custom = 'Custom',
  Interlock = 'Interlock',
  Standard = 'Standard'
}

export type PanelSupplierAudience = CintAudience | CustomAudience | ProlificAudience;

export enum PanelistPoolType {
  Exclusive = 'exclusive',
  Inclusive = 'inclusive'
}

export type PresetAudienceGql = {
  __typename?: 'PresetAudienceGQL';
  createdDate: Scalars['String']['output'];
  incidenceRate: Scalars['Int']['output'];
  isDefault: Scalars['Boolean']['output'];
  isWeighted: Scalars['Boolean']['output'];
  locale: Locale;
  members: Array<FlatDraftFieldworkAudienceMember>;
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  presetAudienceId: Scalars['ID']['output'];
};

export type PresetAudienceInputInput = {
  incidenceRate: Scalars['Int']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  locale: LocaleInput;
  members: Array<DraftFieldworkAudienceMemberInputInput>;
  name: Scalars['String']['input'];
  position: Scalars['Int']['input'];
  presetAudienceId: Scalars['ID']['input'];
};

export type PresetCustomOption = {
  __typename?: 'PresetCustomOption';
  isQualifying: Scalars['Boolean']['output'];
  quota: Scalars['Float']['output'];
  value: Scalars['String']['output'];
};

export type PresetCustomQuestion = {
  __typename?: 'PresetCustomQuestion';
  options: Array<PresetOption>;
  quotasEnabled: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  type: Scalars['Int']['output'];
};

export type PresetOption = PresetCustomOption | PresetStandardOption;

export type PresetQuestion = PresetCustomQuestion | PresetStandardQuestion;

export type PresetStandardOption = {
  __typename?: 'PresetStandardOption';
  isQualifying: Scalars['Boolean']['output'];
  optionCode: Scalars['String']['output'];
  quota: Scalars['Float']['output'];
};

export type PresetStandardQuestion = {
  __typename?: 'PresetStandardQuestion';
  audienceCriterionCode: Scalars['String']['output'];
  options: Array<PresetOption>;
  quotasEnabled: Scalars['Boolean']['output'];
  type: Scalars['Int']['output'];
};

export type ProlificAudience = {
  __typename?: 'ProlificAudience';
  countryId: Scalars['Int']['output'];
  description: Scalars['String']['output'];
  filters?: Maybe<Scalars['Json']['output']>;
};

export type Qualification = {
  __typename?: 'Qualification';
  createdDate: Scalars['Instant']['output'];
  sinceDate: Scalars['Instant']['output'];
};

export type QualificationInput = {
  createdDate: Scalars['String']['input'];
  sinceDate: Scalars['String']['input'];
};

export type Question = {
  __typename?: 'Question';
  createdDate: Scalars['Instant']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  questionId: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  textStyling?: Maybe<Scalars['String']['output']>;
};

export type QuestionImage = {
  __typename?: 'QuestionImage';
  imageName: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
};

export type QuestionInput = {
  createdDate: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  questionId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
  textStyling?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionItem = {
  __typename?: 'QuestionItem';
  maxDiffSpecification?: Maybe<MaxDiffSpecification>;
  question: LocalisedQuestion;
  questionImage?: Maybe<QuestionImage>;
  questionLogic: Array<Array<LogicClauseProposition>>;
  questionMedia?: Maybe<QuestionMedia>;
  questionScale?: Maybe<QuestionScale>;
  questionTypeCode: Scalars['String']['output'];
  responseOptions: Array<EntryResponseOption>;
  responseOptionsLogic?: Maybe<ResponseOptionsLogic>;
  settingValues: Array<EntrySettingValue>;
};

export enum QuestionKind {
  AudienceKind = 'AudienceKind',
  QuestionnaireKind = 'QuestionnaireKind'
}

export type QuestionMedia = {
  __typename?: 'QuestionMedia';
  createdDate: Scalars['String']['output'];
  mediaName: Scalars['String']['output'];
  mediaType: MediaType;
  mediaUrl: Scalars['String']['output'];
  renderedMediaUrl?: Maybe<Scalars['String']['output']>;
  sinceDate: Scalars['String']['output'];
};

export type QuestionResponseOption = {
  __typename?: 'QuestionResponseOption';
  questionId: Scalars['ID']['output'];
  responseOptionId: Scalars['ID']['output'];
};

export type QuestionResponseOptionCount = {
  __typename?: 'QuestionResponseOptionCount';
  count: Scalars['Int']['output'];
  questionId: Scalars['ID']['output'];
};

export type QuestionResponseOptionRank = {
  __typename?: 'QuestionResponseOptionRank';
  questionId: Scalars['ID']['output'];
  ranked: Scalars['Int']['output'];
  responseOptionId: Scalars['ID']['output'];
};

export type QuestionScale = {
  __typename?: 'QuestionScale';
  labels: Array<QuestionScaleLabel>;
  range: ScaleRange;
};

export type QuestionScaleLabel = {
  __typename?: 'QuestionScaleLabel';
  label: LocalisedScaleLabel;
  labelTranslations: Array<ScaleLabelTranslation>;
  position: Scalars['Int']['output'];
};

export type QuestionTargetingIds = {
  __typename?: 'QuestionTargetingIds';
  questionId: Scalars['ID']['output'];
  targetingIds: Array<RoCintTargetingId>;
};

export type QuestionnaireEntry = {
  __typename?: 'QuestionnaireEntry';
  contextPosition: Scalars['Int']['output'];
  createdDate: Scalars['String']['output'];
  entryItem: EntryItem;
  entryType: EntryType;
  forks: Array<ForkTag>;
  loopingSourceQuestionId?: Maybe<Scalars['ID']['output']>;
  loopingSourceResponseOptionId?: Maybe<Scalars['ID']['output']>;
  metadata?: Maybe<Scalars['Json']['output']>;
  number: Scalars['Int']['output'];
  position: Scalars['Int']['output'];
  questionKind: QuestionKind;
  sectionId?: Maybe<Scalars['ID']['output']>;
  sinceDate: Scalars['String']['output'];
};

export type Quota = {
  __typename?: 'Quota';
  createdDate: Scalars['Instant']['output'];
  percent: Scalars['Float']['output'];
  sinceDate: Scalars['Instant']['output'];
};

export type QuotaInput = {
  createdDate: Scalars['String']['input'];
  percent: Scalars['Float']['input'];
  sinceDate: Scalars['String']['input'];
};

export type QuotaKey = {
  __typename?: 'QuotaKey';
  questionId: Scalars['ID']['output'];
  responseOptionId: Scalars['ID']['output'];
};

export type QuotaKeyInput = {
  questionId: Scalars['ID']['input'];
  responseOptionId: Scalars['ID']['input'];
};

export enum QuotasState {
  Disabled = 'Disabled',
  Enabled = 'Enabled'
}

export type Randomised = {
  __typename?: 'Randomised';
  /** Fake field because GraphQL does not support empty objects. Do not query, use __typename instead. */
  _?: Maybe<Scalars['Boolean']['output']>;
};

export type ResponseOption = {
  __typename?: 'ResponseOption';
  createdDate: Scalars['Instant']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  responseOptionId: Scalars['ID']['output'];
  rotype: ResponseOptionType;
  value: Scalars['String']['output'];
};

export type ResponseOptionInput = {
  createdDate: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  responseOptionId: Scalars['ID']['input'];
  rotype: ResponseOptionType;
  value: Scalars['String']['input'];
};

export type ResponseOptionInputInput = {
  responseOptionId?: InputMaybe<Scalars['ID']['input']>;
  responseOptionType: ResponseOptionType;
  responseOptionValue: Scalars['String']['input'];
};

export type ResponseOptionLoopSourcePair = {
  __typename?: 'ResponseOptionLoopSourcePair';
  loopSourceId: Scalars['ID']['output'];
  responseOptionId: Scalars['ID']['output'];
};

export type ResponseOptionMedia = {
  __typename?: 'ResponseOptionMedia';
  mediaName: Scalars['String']['output'];
  mediaType: MediaType;
  mediaUrl: Scalars['String']['output'];
  renderedMediaUrl?: Maybe<Scalars['String']['output']>;
};

export type ResponseOptionMediaInput = {
  mediaName: Scalars['String']['input'];
  mediaType: MediaType;
  mediaUrl: Scalars['String']['input'];
  renderedMediaUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ResponseOptionSet = {
  __typename?: 'ResponseOptionSet';
  responseOptions: Array<Scalars['Int']['output']>;
  setNumber: Scalars['Int']['output'];
};

export enum ResponseOptionType {
  RoDouble = 'RoDouble',
  RoInt = 'RoInt',
  RoLink = 'RoLink',
  RoString = 'RoString'
}

export type ResponseOptionsLogic = {
  __typename?: 'ResponseOptionsLogic';
  condition: ResponseOptionsLogicCondition;
  exemptResponseOptionIds: Array<Scalars['ID']['output']>;
  maxResponseOptionsToDisplay: Scalars['Int']['output'];
};

export type ResponseOptionsLogicCondition = LoopQuotaPriority | Randomised;

export type RoCintTargetingId = {
  __typename?: 'RoCintTargetingId';
  cintAgeMax?: Maybe<Scalars['Int']['output']>;
  cintAgeMin?: Maybe<Scalars['Int']['output']>;
  cintGenderId?: Maybe<Scalars['Int']['output']>;
  cintRegionId?: Maybe<Scalars['Int']['output']>;
  cintVariableId?: Maybe<Scalars['Int']['output']>;
  responseOptionId: Scalars['ID']['output'];
};

export type Route = {
  __typename?: 'Route';
  createdDate: Scalars['String']['output'];
  sinceDate: Scalars['String']['output'];
  targetNumber: Scalars['Int']['output'];
};

export type SamplesNeeded = {
  __typename?: 'SamplesNeeded';
  adjusted: Scalars['Int']['output'];
  unadjusted: Scalars['Int']['output'];
};

export type ScaleLabelTranslation = {
  __typename?: 'ScaleLabelTranslation';
  country: Scalars['String']['output'];
  language: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type ScaleRange = {
  __typename?: 'ScaleRange';
  createdDate: Scalars['String']['output'];
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  sinceDate: Scalars['String']['output'];
  startingPosition: Scalars['Float']['output'];
  step: Scalars['Float']['output'];
};

export type SectionItem = {
  __typename?: 'SectionItem';
  loopingConfig?: Maybe<LoopingConfig>;
  sectionId: Scalars['ID']['output'];
  sectionMaskingRules: Array<MaskingRule>;
  settingValues: Array<EntrySettingValue>;
  title: Scalars['String']['output'];
};

export type SettingInputInput = {
  memberSettingCode: Scalars['String']['input'];
  settingValue: Scalars['String']['input'];
};

export enum SettingType {
  SInt = 'SInt',
  SString = 'SString'
}

export type SoftLaunch = {
  __typename?: 'SoftLaunch';
  samplesNeeded: Scalars['Int']['output'];
};

export type SoftLaunchInput = {
  samplesNeeded: Scalars['Int']['input'];
};

export type SourceMatrixRowQuota = {
  __typename?: 'SourceMatrixRowQuota';
  questionId: Scalars['ID']['output'];
  quotaTarget: Scalars['Int']['output'];
};

export type StagnantQuotaInput = {
  keys: Array<QuotaKeyInput>;
  samplesRemainingPercentage: Scalars['Float']['input'];
};

export type StandardAudienceCriterionOption = {
  __typename?: 'StandardAudienceCriterionOption';
  criterionOption: AudienceCriterionOption;
  metadata?: Maybe<Scalars['Json']['output']>;
  position: Scalars['Int']['output'];
  qualification?: Maybe<Qualification>;
  quota?: Maybe<Quota>;
  state: StandardAudienceCriterionOptionState;
  weight?: Maybe<Weight>;
};

export type StandardAudienceCriterionOptionInput = {
  criterionOption: AudienceCriterionOptionInput;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  position: Scalars['Int']['input'];
  qualification?: InputMaybe<QualificationInput>;
  quota?: InputMaybe<QuotaInput>;
  state: StandardAudienceCriterionOptionState;
  weight?: InputMaybe<WeightInput>;
};

export enum StandardAudienceCriterionOptionState {
  Disabled = 'Disabled',
  Enabled = 'Enabled'
}

export type StandardAudienceItem = {
  __typename?: 'StandardAudienceItem';
  criterion: AudienceCriterion;
  quotasState: QuotasState;
  standardCriterionOptions: Array<StandardAudienceCriterionOption>;
};

export type StandardCriterion = {
  __typename?: 'StandardCriterion';
  createdDate: Scalars['String']['output'];
  criterion: AudienceCriterion;
  sinceDate: Scalars['String']['output'];
  state: AudienceCriterionState;
};

export type StandardCriterionOptionValidationErrors = {
  __typename?: 'StandardCriterionOptionValidationErrors';
  code: Scalars['String']['output'];
  errors: Array<StandardOptionValidationError>;
};

export enum StandardCriterionValidationError {
  InvalidDisplayLogicSourceError = 'InvalidDisplayLogicSourceError',
  InvalidQuotaSumError = 'InvalidQuotaSumError',
  MissingQualificationError = 'MissingQualificationError',
  MissingQualifyingSettingWarning = 'MissingQualifyingSettingWarning',
  MissingQuotasSettingWarning = 'MissingQuotasSettingWarning'
}

export type StandardCriterionValidationErrors = {
  __typename?: 'StandardCriterionValidationErrors';
  code: Scalars['String']['output'];
  errors: Array<StandardCriterionValidationError>;
  standardCriterionOptionsErrors: Array<StandardCriterionOptionValidationErrors>;
};

export type StandardCriterionWithOptions = {
  __typename?: 'StandardCriterionWithOptions';
  criterion: AudienceCriterion;
  options: Array<AudienceCriterionOption>;
  state: AudienceCriterionState;
};

export enum StandardOptionValidationError {
  AgeBandsGapError = 'AgeBandsGapError',
  AgeRangeOverlapError = 'AgeRangeOverlapError',
  DuplicateCustomizedCriterionOptionCodeError = 'DuplicateCustomizedCriterionOptionCodeError',
  InvalidCustomizedCriterionOptionCodeError = 'InvalidCustomizedCriterionOptionCodeError',
  InvalidQualificationError = 'InvalidQualificationError',
  MinAgeBiggerThanMaxError = 'MinAgeBiggerThanMaxError',
  QuotaIsZeroError = 'QuotaIsZeroError',
  String = 'String'
}

export type TextCardItem = {
  __typename?: 'TextCardItem';
  questionLogic: Array<Array<LogicClauseProposition>>;
  questionMedia?: Maybe<QuestionMedia>;
  settingValues: Array<EntrySettingValue>;
  textCard: LocalisedTextCard;
};

export enum TextEntryState {
  TextEntryDisabled = 'TextEntryDisabled',
  TextEntryEnabled = 'TextEntryEnabled'
}

export type Weight = {
  __typename?: 'Weight';
  createdDate: Scalars['Instant']['output'];
  percent: Scalars['Float']['output'];
};

export type WeightInput = {
  createdDate: Scalars['String']['input'];
  percent: Scalars['Float']['input'];
};

export type WeightKey = {
  __typename?: 'WeightKey';
  questionId: Scalars['ID']['output'];
  responseOptionId: Scalars['ID']['output'];
};

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { __typename: 'ConfigQueries', countries: Array<{ __typename: 'Country', name: string, countryCode: string, languageName: string, locale: { __typename: 'Locale', language: string, country: string } }> };

export type FieldworkAudienceQueryVariables = Exact<{
  surveyId: Scalars['ID']['input'];
}>;


export type FieldworkAudienceQuery = { __typename: 'ConfigQueries', fieldworkAudience?: { __typename: 'FieldworkAudience', surveyId: string, createdDate: string, sinceDate: string, entries: Array<{ __typename: 'QuestionnaireEntry', number: number, position: number, contextPosition: number, createdDate: string, sinceDate: string, entryType: EntryType, entryItem: { __typename: 'ForkItem' } | { __typename: 'MatrixItem' } | { __typename: 'QuestionItem', questionTypeCode: string, question: { __typename: 'LocalisedQuestion', questionId: string, text: string, createdDate: any }, responseOptions: Array<{ __typename: 'EntryResponseOption', position: number, createdDate: string, sinceDate: string, responseOption: { __typename: 'LocalisedResponseOption', responseOptionId: string, rotype: ResponseOptionType, value: string, createdDate: any }, qualification?: { __typename: 'Qualification', createdDate: any, sinceDate: any } | null, route?: { __typename: 'Route', sinceDate: string, targetNumber: number } | null }>, settingValues: Array<{ __typename: 'EntrySettingValue', code: string, value: string, createdDate: string, sinceDate: string }> } | { __typename: 'SectionItem' } | { __typename: 'TextCardItem' } }>, quotas: Array<{ __typename: 'FieldworkQuota', percent: number, respondentCount: number, key?: { __typename: 'QuotaKey', questionId: string, responseOptionId: string } | null }> } | null };


export const CountriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"countries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"countryCode"}},{"kind":"Field","name":{"kind":"Name","value":"languageName"}},{"kind":"Field","name":{"kind":"Name","value":"locale"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"country"}}]}}]}}]}}]} as unknown as DocumentNode<CountriesQuery, CountriesQueryVariables>;
export const FieldworkAudienceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fieldworkAudience"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","alias":{"kind":"Name","value":"fieldworkAudience"},"name":{"kind":"Name","value":"fieldworkAudience"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"surveyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"surveyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"surveyId"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"sinceDate"}},{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"contextPosition"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"sinceDate"}},{"kind":"Field","name":{"kind":"Name","value":"entryType"}},{"kind":"Field","name":{"kind":"Name","value":"entryItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"QuestionItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"questionTypeCode"}},{"kind":"Field","name":{"kind":"Name","value":"question"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"questionId"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"responseOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"sinceDate"}},{"kind":"Field","name":{"kind":"Name","value":"responseOption"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"responseOptionId"}},{"kind":"Field","name":{"kind":"Name","value":"rotype"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"qualification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"sinceDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"route"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sinceDate"}},{"kind":"Field","name":{"kind":"Name","value":"targetNumber"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"settingValues"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"createdDate"}},{"kind":"Field","name":{"kind":"Name","value":"sinceDate"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"quotas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"key"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"questionId"}},{"kind":"Field","name":{"kind":"Name","value":"responseOptionId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"percent"}},{"kind":"Field","name":{"kind":"Name","value":"respondentCount"}}]}}]}}]}}]} as unknown as DocumentNode<FieldworkAudienceQuery, FieldworkAudienceQueryVariables>;